import * as React from 'react';
import { useState } from 'react';

import { UIButton } from '~shared/components/buttons';
import { CustomerPortalSessionForm } from '~teacher/components/Account/CustomerPortalSessionForm';

import { sleep } from '../../../../../../../util/sleep';

interface ManageSeatsButtonProps {
  onSubmit?: () => void;
  onSubmitClick?: () => void;
  selectedTeamId: string;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function ManageSeatsButton({
  selectedTeamId,
  onSubmit,
  onSubmitClick,
  isLoading = false,
  children,
}: ManageSeatsButtonProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <CustomerPortalSessionForm
      key={'manage-subscription-add-seats'}
      source="account_page_teams__add_seats_dialog"
      teamId={selectedTeamId}
      onSubmit={onSubmit}
    >
      <input name="action" id="action" value="switch_plan" readOnly hidden />
      <input
        name="team_id"
        id="team_id"
        value={selectedTeamId}
        readOnly
        hidden
      />
      <UIButton
        isLoading={isLoading || isSubmitting}
        type="submit"
        appearance="primary"
        onClick={() => {
          onSubmitClick?.();
          sleep(5000).then(() => {
            setIsSubmitting(false);
          });
        }}
      >
        {children}
      </UIButton>
    </CustomerPortalSessionForm>
  );
}
